import { Component, OnInit, Input, Output, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { User } from '../../models/user';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';
import { UserForm } from '../../models/forms/user-form';
import { Group } from '../../models/group';

@Component({
  selector: 'app-user-table',
  templateUrl: './user-table.component.html',
  styleUrls: ['./user-table.component.css']
})
export class UserTableComponent implements OnInit, AfterViewInit {
  @Input() data: MatTableDataSource<User> = new MatTableDataSource();
  @Input() groups: Group[];
  @Output() changes: EventEmitter<FormGroup> = new EventEmitter();
  displayedColumns: string[] = ['Email', 'EmailVerified', 'Status', 'LastModifiedDate', 'CreatedDate'];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(public dialog: MatDialog, private fb: FormBuilder) { }

  ngOnInit() {
  }

  openDialog(event) {
    let formGroup: FormGroup;
    const rec = this.data.data.find(n => n.Username === event);
    const config: MatDialogConfig = new MatDialogConfig();

    formGroup = this.fb.group(new UserForm(rec, this.fb));
    // config.width =  '70%';
    // config.height = '90%';
    const grplist: Group[] = [];

    this.groups.forEach(n => {
      const i = rec.Groups.find(x => x.Name === n.Name);

      if (!i) {
        grplist.push(n);
      }
    });

    rec.Groups.forEach(n => {
      const i = this.groups.find(x => x.Name === n.Name);
      n.Precedence = i.Precedence;
    });

    config.data = {
      form: formGroup,
      groups: grplist.sort((a, b) => a.Precedence - b.Precedence)
    };

    const dialgogRef = this.dialog.open(UserDialogComponent, config);

    dialgogRef.afterClosed()
    .subscribe(n => {

      if (n && n.form && n.form.dirty) {
        this.changes.emit(n.form);
      }
    });

  }

  ngAfterViewInit() {
    this.data.paginator = this.paginator;
    this.data.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.data.filter = filterValue.trim().toLowerCase();

    if (this.data.paginator) {
      this.data.paginator.firstPage();
    }
  }
}
